import COLOR from '@Src/commons/Colors';
import { NormalText } from '@Src/commons/StyledComponent';
import { CalendarRegular } from '@fluentui/react-icons';
import { FileUpload } from '@smartpaddle/biz-bamboo.components.data-entry.file-upload';
import { Col, DatePicker, Input, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import moment, { Moment } from 'moment';
import { getBase64 } from './utils';

const { TextArea } = Input;
type initialGrnDataType = {
  document: File | null;
  receivedAt: string | null;
  comments: string | null;
};
type ReceiverDetailsType = {
  setValidation: Function;
  setData: Function;
  data: initialGrnDataType;
  documentDate: string;
};

export default function ReceiverDetails({
  setValidation,
  setData,
  data,
  documentDate,
}: ReceiverDetailsType) {
  const uploadGrnFile = async (
    grnFile: File | null,
    resolve: Function,
    reject: Function
  ) => {
    if (!grnFile) return;
    const base64Url = await getBase64(grnFile);
    setData({ ...data, document: base64Url });
    resolve({});
  };
  const onChange = (value: any, dateString: string) => {
    setData({ ...data, receivedAt: dateString });
  };
  function disabledDate(current: Moment) {
    const getDate = () => {
      if (documentDate) return moment(documentDate);
      return moment(current).subtract(1, 'day');
    };
    const dateStart = getDate();
    const dateEnd = moment().add(1, 'second');
    return !(dateStart.isSameOrBefore(current) && dateEnd.isAfter(current));
  }
  useEffect(() => {
    if (data.receivedAt) {
      setValidation(true);
    } else {
      setValidation(false);
    }
  }, [data.receivedAt]);
  return (
    <div className="screen-width">
      <div className="product-list-container mb-100 p-16">
        <div className="product-list-container">
          <Row className="border-bottom-1">
            <DatePicker
              showTime={{ format: 'HH:mm' }}
              format="DD MMM YYYY, hh:mm a"
              className="w-100"
              bordered={false}
              placeholder="Receipt Date & Time"
              onChange={onChange}
              disabledDate={disabledDate}
              suffixIcon={<CalendarRegular style={{ color: COLOR.GREY_8 }} />}
            />
          </Row>
          <Row className="border-bottom-1">
            <TextArea
              placeholder="Comments (Optional)"
              autoSize
              bordered={false}
              onChange={(e) => setData({ ...data, comments: e.target.value })}
            />
          </Row>
          <Row justify="space-between" className="pl-16 pr-16 pb-12 pt-12">
            <Col>
              <Row>
                <NormalText color={COLOR.GRAY_8} fontSize={14} fontWeight={400}>
                  Supporting Document
                </NormalText>
              </Row>
              <Row>
                <NormalText
                  color={COLOR.GRAY_12}
                  fontSize={12}
                  fontWeight={400}
                >
                  Optional
                </NormalText>
              </Row>
            </Col>
            <Col>
              <Row>
                {' '}
                <FileUpload
                  uploadFileRequest={async (file: File) =>
                    new Promise((resolve, reject) =>
                      uploadGrnFile(file, resolve, reject)
                    )
                  }
                  hasInfoPanel={false}
                  uploadProps={{
                    accept: '.jpg, .jpeg, .png, .gif, .pdf',
                    maxCount: 1,
                    showUploadList: {
                      showDownloadIcon: false,
                      showRemoveIcon: true,
                      showPreviewIcon: false,
                    },
                  }}
                  name="grnFile"
                />
              </Row>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
}
